import { experiment, DestinationFeatureFlags } from '@lib/experiment';

const gaVdmDestinations = new Set([
  'INTERCOM_V2',
  'LINKEDIN_AUDIENCE',
  'FB_CUSTOM_AUDIENCE',
  'CUSTOMERIO_AUDIENCE',
  'GOOGLE_ADWORDS_REMARKETING_LISTS',
  'ZOHO',
  'TIKTOK_AUDIENCE',
]);

export const isVdmNextEnabledForDestination = (destType: string): boolean =>
  gaVdmDestinations.has(destType) ||
  experiment.isDestinationFeatureEnabled(destType, DestinationFeatureFlags.vdmNext);
